import PropTypes from 'prop-types';
import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import { color } from '../../../app/theme';
import defaultPNG from '../../../assets/images/png/img-default-tamplate-img@3x.png';

const useStyles = makeStyles(
  () => ({
    button: {
      width: '100%',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '9px 16px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: 13,
      color: color.$2,
      borderBottom: `1px solid ${color.$9}`,
      textAlign: 'center',
      '&:last-child': {
        border: 'none',
      },
    },
    card: ({ width }) => ({
      flex: '0 0 auto',
      display: 'flex',
      flexDirection: 'column',
      width: width || 204,
      margin: '0 8px 0 0',
      backgroundColor: color.$7,
      borderRadius: 12,
      boxShadow: '0 8px 36px 0 rgba(0, 0, 0, 0.06)',
      '&:last-child': {
        marginRight: 0,
      },
    }),
    imageContainer: {
      width: '100%',
      borderRadius: 12,
      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        borderRadius: '12px 12px 0 0',
        '& > img': {
          width: '100%',
          objectFit: 'cover',
          borderRadius: '12px 12px 0 0',
        },
      },
    },
    'image-type-url': {
      width: 204,
      height: 204,
    },
    textContainer: {
      flex: '1',
      padding: 12,
      borderBottom: `1px solid ${color.$9}`,
      overflowWrap: 'anywhere',
    },
    title: {
      color: color.$3,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
    },
    subtitle: {
      color: color.$11,
      wordBreak: 'break-word',
      whiteSpace: 'pre-wrap',
    },
  }),
  {
    name: 'OptionalCard',
  },
);

function OptionalCard({ data, messageIndex, index, width }) {
  const classes = useStyles({ width });
  const { t } = useTranslation();
  const buttonComponents = data.buttons.map((button, buttonIndex) => {
    if (button.type === 'url') {
      return (
        <a
          className={classes.button}
          key={`preview-${messageIndex}-card-${index}-button-${buttonIndex}`}
          href={button.data}
          target="_blank"
          rel="noopener noreferrer"
        >
          {button.title || t('button')}
        </a>
      );
    }
    return (
      <div
        className={classes.button}
        key={`preview-${messageIndex}-card-${index}-button-${buttonIndex}`}
      >
        {button.title || t('button')}
      </div>
    );
  });

  return (
    <div className={classes.card} key={`preview-${messageIndex}-card-${index}`}>
      <div className={classes.imageContainer}>
        <div>
          <img
            className={classnames({
              [classes['image-type-url']]: data.imageType === 'url',
            })}
            src={
              data.imageUrl && data.imageUrl !== '' ? data.imageUrl : defaultPNG
            }
            alt="preview"
          />
        </div>
      </div>
      <div className={classes.textContainer}>
        <Typography className={classes.title} variant="body1">
          {data.title || t('title')}
        </Typography>
        <Typography className={classes.subtitle} variant="body1">
          {data.subtitle || t('description')}
        </Typography>
      </div>
      {buttonComponents}
    </div>
  );
}

OptionalCard.defaultProps = {
  width: undefined,
};

OptionalCard.propTypes = {
  data: PropTypes.object.isRequired,
  messageIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  width: PropTypes.number,
};

export default OptionalCard;
